enum DocumentStatus {
  temporary = 'temporary',
  active = 'active',
  archived = 'archived',
  deleted = 'deleted',
}

export default DocumentStatus
